import { render, staticRenderFns } from "./my_shop_nav.vue?vue&type=template&id=96f455dc&scoped=true&"
import script from "./my_shop_nav.vue?vue&type=script&lang=js&"
export * from "./my_shop_nav.vue?vue&type=script&lang=js&"
import style0 from "./my_shop_nav.vue?vue&type=style&index=0&id=96f455dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f455dc",
  null
  
)

export default component.exports